import type { AppRouteQuery, AppRoute } from '@acre-rewards/lib'

export function generateTagTypesFromContract<const TContract extends Record<string, AppRoute>>({
  contract,
}: {
  contract: TContract
}) {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const queryTags = Object.entries(contract)
    .filter(([, route]) => route.method === 'GET')
    .map(([endpoint]) => endpoint) as unknown as {
    [key in keyof TContract]: TContract[key] extends AppRouteQuery ? key : never
  }[keyof TContract][]

  const tags = ['UNAUTHORIZED' as const, ...queryTags]

  return tags
}
